<template>
  <v-toolbar flat class="fill-height">
    <v-menu offset-y v-if="!isSelectMode">
      <template v-slot:activator="{ on }">
        <button
          v-ripple
          v-on="on"
          data-test="tableAction"
          class="d-flex justify-space-between align-center btn-reset"
        >
          <h6
            class="capitalize-first-letter headline font-weight-medium primary--text text-h6 text-no-wrap"
          >
            {{ collectionType }}
          </h6>
          <v-icon color="primary" v-if="pageActions">
            mdi-menu-down
          </v-icon>
        </button>
      </template>
      <v-list min-width="170" v-if="pageActions">
        <v-list-item
          :data-test-dropdown="item.action"
          dense
          :disabled="!item._enabled"
          @click="handleAction(item.action)"
          v-for="(item, index) in pageActions"
          :key="index"
        >
          <v-icon>{{ item.icon }}</v-icon>
          <v-list-item-title class="ml-6">{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <span class="headline font-weight-medium primary--text d-flex" v-else>
      <v-btn @click="$emit('deselect')" icon color="primary">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <span class="my-auto">Selected: {{ selected.length }}</span>
    </span>
    <v-spacer />
    <div
      :class="{ 'pr-7': isSelectMode && !isMobile, 'border-accent': !isMobile }"
      v-if="isSelectMode"
    >
      <v-btn
        icon
        @click="handleAction('massiveAccessRights')"
        color="primary"
        class="mr-2"
        v-if="!isMobile && showAccess"
      >
        <v-icon>mdi-security</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }" v-if="selectedActions">
          <v-btn v-on="on" icon color="primary">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list style="width: 247px" v-if="selectedActions">
          <v-list-item
            dense
            :disabled="!item._enabled"
            class="px-6"
            v-for="item in selectedActions"
            :key="item.id"
            @click="handleAction(item.action)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <div class="ml-7" v-if="(isMobile && !isSelectMode) || !isMobile">
      <v-btn
        :disabled="collectionType === 'dataTypes'"
        data-test="tableSort"
        icon
        title="Filter"
        color="primary"
        class="mr-2"
        @click="handleAction('changeFilters')"
      >
        <v-badge
          color="#D50000"
          offset-x="5px"
          offset-y="1px"
          dot
          :value="isFilterChanged"
        >
          <v-icon>mdi-tune</v-icon>
        </v-badge>
      </v-btn>
      <dropdown-menu
        v-if="isMobile"
        :items="sort"
        item-key-text="text"
        item-key-value="value"
        :item-id-selected="itemIdSelected"
        @input="handleSort($event)"
      >
        <template v-slot:activator="{ on }">
          <slot name="activator" :on="on">
            <v-btn icon color="primary" v-on="on" slot="activator">
              <v-icon>mdi-sort</v-icon>
            </v-btn>
          </slot>
        </template>
      </dropdown-menu>
      <v-btn
        :disabled="collectionType === 'dataTypes'"
        data-test="tableSettings"
        v-else
        icon
        title="Table settings"
        color="primary"
        @click="handleAction('changeSettings')"
      >
        <v-icon>mdi-cog</v-icon>
      </v-btn>
    </div>
  </v-toolbar>
</template>

<script>
import DropdownMenu from '@/components/DropdownMenu';
import camelCase from 'lodash.camelcase';
export default {
  name: 'tableToolbar',
  props: [
    'selected',
    'title',
    'selectedActions',
    'pageActions',
    'columns',
    'isFilterChanged',
    'showAccess'
  ],
  components: {
    DropdownMenu
  },
  data() {
    return {
      itemIdSelected: null
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    collectionType() {
      return this.collection;
    },
    isSelectMode() {
      return this.selected.length > 0;
    },
    collection() {
      return this.title;
    },
    sortName() {
      switch (this.$route.name) {
        case 'users':
          return 'login';
        case 'notifications':
          return 'objectName';
        default:
          return 'name';
      }
    },
    sort() {
      let columns = this.columns
        .filter(item => item.sortable && item.showOnMobile)
        .map(item => ({
          value: item.value,
          desc: true,
          text: `${item.text}`,
          _enabled: true
        }));

      return [
        {
          value: null,
          text: 'Default',
          _enabled: true
        },
        {
          value: this.sortName,
          text: 'Name (A-Z)',
          _enabled: true
        },
        {
          value: this.sortName,
          text: 'Name (Z-A)',
          desc: true,
          _enabled: true
        },
        ...columns
      ];
    }
  },
  methods: {
    handleAction(v) {
      this.$emit('action', v);
    },
    handleSort(e) {
      this.itemIdSelected = e.raw.text;
      this.$emit('filter-up', {
        desc: e.raw.desc ? [e.raw.desc] : [],
        sort: e.id ? [e.id] : []
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.btn-reset
  outline: none

.border-accent
  border-right: 1px solid #2780E3

.capitalize-first-letter::first-letter
  text-transform: capitalize

</style>
